import { ProcessStepFromQuoteRequestLine } from "#modules/similarPart/view/clustering/CompareCard";

export const normalizeProductLines = ({
  productLines,
  quoteRequestLineQuantity,
}: {
  productLines: ProcessStepFromQuoteRequestLine["productLines"] | undefined;
  quoteRequestLineQuantity: number;
}) => {
  return (
    productLines?.map((productLine) => {
      if (!productLine.isQuantityPerPart) {
        return {
          ...productLine,
          quantity: productLine.quantity / quoteRequestLineQuantity,
          isQuantityPerPart: true,
        };
      }

      return productLine;
    }) ?? []
  );
};
